import { Alert, Container, Spinner } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import {
	CreateWATemplateForm,
	useFetchIntegration,
} from "../../../../Integrations"
import { generatePath, useNavigate, useParams } from "../../../../router-utils"

export default function WhatsAppIntegrationTemplateCreatePage() {
	const navigate = useNavigate()
	const { integrationId } = useParams(
		"/integrations/:integrationId/whatsapp/templates/new"
	)
	const {
		data: integration,
		error: integrationError,
		isValidating: integrationLoading,
	} = useFetchIntegration(integrationId)

	if (!integration?.integrated_app_id) {
		if (integrationLoading) {
			return <Spinner padding="8" alignCenter />
		}

		return (
			<Alert status="warning">
				{integrationError?.message ||
					"Unable to load the WhatsApp integration."}
			</Alert>
		)
	}

	const templatesPath = generatePath(
		"/integrations/:integrationId/whatsapp/templates",
		{ integrationId }
	)

	return (
		<>
			<Helmet>
				<title>New WhatsApp Template</title>
			</Helmet>
			<Breadcrumbs
				title="New WhatsApp Template"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[templatesPath, integration.name],
					["", "New WhatsApp Template"],
				]}
			/>
			<Container paddingY="6" bgColor="default">
				<CreateWATemplateForm
					integratedAppId={integration.integrated_app_id}
					onDone={() =>
						navigate("/integrations/:integrationId/whatsapp/templates", {
							params: { integrationId },
							replace: true,
						})
					}
				/>
			</Container>
		</>
	)
}
